import { connect } from 'react-redux';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import {
  CarSegmentDetails,
  CarSegmentResponse,
} from '../../../../../../models/itinerary';
import { AppState } from '../../../../../../store/model';
import { getSegmentResponse, isSaviSelectIntl } from '../../../../../../store/reducers/itinerary/selectors';
import { getSegmentOption } from '../../../../../../store/reducers/segment-options/selectors';
import { CarRoute as CarRouteLab } from '../../../../../lab/Route/CarRoute';
import { getACarDetailsForSaviSelectIntl } from '../../../../../../store/reducers/itinerary/saviSelectIntlSelector';

interface OwnProps {
  optionId: string;
  segmentId: number;
}

interface StateProps {
  pickupAddress: CarSegmentDetails['pickupAddress'];
  pickupCity: CarSegmentDetails['pickupCity'];
  pickupDate: CarSegmentResponse['pickupDate'];
  dropoffAddress: CarSegmentDetails['dropoffAddress'];
  dropoffCity: CarSegmentDetails['dropoffCity'];
  dropoffDate: CarSegmentResponse['dropoffDate'];
  isSaviSelectIntl: boolean;
}

interface CarProps extends StateProps {}

const mapStateToProps = (
  state: AppState,
  { segmentId, optionId }: OwnProps,
) => {
  if(!isSaviSelectIntl(state)) {
    const details = getSegmentResponse(segmentId)(state) as CarSegmentResponse;
    const { pickupDate, pickupCityName, dropoffDate } = details;

    const { pickupCity, dropoffAddress, dropoffCity } = getSegmentOption(
      segmentId,
      optionId,
    )(state) as CarSegmentDetails;

    return {
      pickupCity,
      pickupDate,
      pickupCityName,
      dropoffAddress,
      dropoffCity,
      dropoffDate,
      isSaviSelectIntl: false,
    };
  } else {
    const car = getACarDetailsForSaviSelectIntl(segmentId, Number(optionId))(state);

    return {
      pickupAddress: car!.pickupAddress,
      pickupCity: car!.pickupCityName,
      pickupDate: car!.pickupDateAndTime,
      dropoffAddress: car!.dropoffAddress,
      dropoffCity: car!.pickupCityName,
      dropoffDate: car!.dropoffDateAndTime,
      isSaviSelectIntl: true,
    };
  }
};

const enhance = compose<CarProps, OwnProps>(
  pure,
  connect(mapStateToProps),
);

export const CarRoute = enhance(CarRouteLab);

CarRoute.displayName = 'CarRoute';
